export default "__VITE_ASSET__69b2562c__"